export type ClassValue = string | false | null | undefined;

/**
 * Joins the truthy string arguments with a single space, skipping any
 * falsy values. Local replacement for the `classnames` package.
 */
export function classNames(...values: ClassValue[]): string {
    return values.filter(Boolean).join(" ");
}
